import React, { useState } from 'react';
import insuranceImage from '../../assets/refer.png'; // Update with your image path
import pollutionImage from '../../assets/refer.png'; // Update with your image path

const VehicalDoc = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const documents = [
    { id: 1, label: "Insurance", image: insuranceImage },
    { id: 2, label: "Pollution Certificate", image: pollutionImage },
    { id: 3, label: "Insurance", image: insuranceImage },
  ];

  const handleToggle = (index) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  return (
    <div className="flex flex-col items-center py-8 w-full  bg-gray-50">
      {documents.map((doc, index) => (
        <div
          key={doc.id}
          className="w-full max-w-md mb-4 cursor-pointer"
          onClick={() => handleToggle(index)}
        >
          <div className="overflow-hidden rounded-lg bg-gray-300 ">
            <img
              src={doc.image}
              alt={doc.label}
              className={`w-full transition-all duration-300 ${expandedIndex === index ? 'h-48' : 'h-12'}`}
            />
            <div className="bg-[#FF9630] text-center text-white py-2 font-medium rounded-b-lg">
              {doc.label}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VehicalDoc;
